import httpClient from "@/apis/base/axios-httpclient";
import BaseAPI from "./base/base-api";
import qs from "qs";

class ContextAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "context";

  /**
   * Lấy token đăng nhập
   */
  getToken(param) {
    let queryString = qs.stringify(param);
    let request = {
      url: [this.getAPIUrl(), "/token?", queryString].join(""),
      withCredentials: true,
    };

    return httpClient.getAsync(request);
  }
}

export default new ContextAPI();
